type Props = {
  variant?: "full" | "mark";
  className?: string;
};

/**
 * EtherMarket logo: three ascending bars forming an uptrend / bar-chart motif
 * in the primary fintech blue, paired with the wordmark.
 */
export default function EtherMarketLogo({ variant = "full", className = "" }: Props) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true">
        <rect width="28" height="28" rx="7" fill="#1652f0" />
        <rect x="7" y="16" width="4" height="5" rx="1" fill="white" />
        <rect x="12" y="11" width="4" height="10" rx="1" fill="white" />
        <rect x="17" y="7" width="4" height="14" rx="1" fill="white" />
      </svg>
      {variant === "full" && (
        <span className="text-lg font-bold tracking-tight text-ink">EtherMarket</span>
      )}
    </span>
  );
}
